import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { API }                         from '../api/api.constant';
import { ApiService }                  from '../api/api.service';
import { ReminderDefaultsModel }       from './typings/reminders.defaults';
import { RemindersModel }              from './typings/reminders';
import { SendRemindersComponent }      from './reminders.send.component';
import { RemindersSufficientSMSModel } from './typings/reminders.sufficient-sms';

@Injectable({
  providedIn: 'root'
})
export class RemindersService {
  _API = API;

  constructor (
    private apiService  : ApiService,
    private modalService: NgbModal
  ) {}

  buySms ( amount : number | string ) : Promise<any> {
    return this.apiService.get('/sms_logs/purchase', [
      true,
      amount
    ]);
  }

  confirmReminders ( reminders : RemindersModel ) : Promise<any> {
    return this.apiService.post('/system/send_service_reminders', reminders)
    .then(data => {
      window.open(`${ this._API.url }/reports/jasper_service_reminders.pdf`);

      return data;
    });
  }

  send () : Promise<any> {
    return this.apiService.get('/system/service_reminder_defaults/')
    .then(( defaults : ReminderDefaultsModel ) => {
      const modalRef = this.modalService.open(SendRemindersComponent, {
        size       : 'lg',
        windowClass: 'service-reminders'
      });

      modalRef.componentInstance.defaults = defaults;

      return modalRef.result;
    });
  }

  verifySmsAvailability ( reminders : RemindersModel ) : Promise<RemindersSufficientSMSModel> {
    return this.apiService.get('/system/sms_sufficient_for_service_reminders', [
      reminders.start_date,
      reminders.end_date
    ]);
  }
}
